import { PermissionNames } from '@getgreenline/homi-shared'
import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { AppMainView, AppView } from '../../../components/AppView'
import AppHeader from '../../../components/AppView/Header'
import { HelpLinkMenu, HelpMenu } from '../../../components/GrDropdown/HelpLinkMenu/HelpLinkMenu'
import { NoPermissionsResult } from '../../../components/NoPermissionsResult'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../stores/CurrentUserStore'
import './index.scss'
import { HelpLinks } from '../../../constants/ExternalLinks'

const capitalize = (input: string) => input.charAt(0).toUpperCase() + input.slice(1)

interface Props {
  currentCompanyStore: CurrentCompanyStore
  currentUserStore: CurrentUserStore
  children: React.ReactElement
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class DashboardSettingsRoot extends React.Component<Props, {}> {
  company = this.props.currentCompanyStore!.company!

  private getRoutePath() {
    return capitalize(this.props.children.props.route.path.replace(/([A-Z])/g, ' $1')).toLowerCase()
  }

  get headerTitle() {
    const routePath = this.getRoutePath()
    let headerTitle: string

    switch (routePath) {
      case 'pos':
        headerTitle = 'POS'
        break
      case 'giftcards':
        headerTitle = 'Gift cards'
        break
      case 'digital signage':
        headerTitle = 'Digital Signage (Beta)'
        break
      default:
        headerTitle = routePath
    }
    return headerTitle
  }

  get helpLinkMenus(): HelpMenu[] {
    const defaultHelpMenus = [
      {
        href: HelpLinks.SETTINGS,
        title: 'Settings',
      },
    ]

    return defaultHelpMenus
  }

  render() {
    const userCanEditCompanyDetails = this.props.currentUserStore!.hasPermissionAtEntity(
      PermissionNames.CAN_EDIT_COMPANY_DETAILS,
      this.company.id,
    )
    return (
      <AppView column>
        <AppHeader title={this.headerTitle}>
          {this.helpLinkMenus && <HelpLinkMenu helpLinkMenus={this.helpLinkMenus} />}
        </AppHeader>

        <AppMainView className='background-grey intercom-pb-2'>
          {userCanEditCompanyDetails ? (
            this.props.children
          ) : (
            <NoPermissionsResult permissionName={PermissionNames.CAN_EDIT_COMPANY_DETAILS} />
          )}
        </AppMainView>
      </AppView>
    )
  }
}
